import React, { Fragment, Component } from 'react';
import Swal from 'sweetalert2'
import axios from 'axios';
import Qs from 'qs'
import { Link } from 'react-router-dom';
import {
  Badge,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Modal,
  ModalBody,
  ModalHeader,
  FormGroup,
  Input
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LANG } from '../../lang';
import { getRealImageSrc } from 'session';
import ModalFooter from 'reactstrap/lib/ModalFooter';

export default class MainHeaderUser extends Component {
  constructor(props) {
    super(props);
    this.state = { update_password: false, is_admin: 0, logoutAction: false, error_info: "", root_user: props.root_user !== undefined ? props.root_user : false, show_login: false, email: "", password: "", lang_version: props.lang_version, uname: "", uimage: "", upassword: "" };
  }


  componentDidMount() {
    let session = window.localStorage;
    let ch_isLogin = session.ch_isLogin;
    let uname = session.ch_uname;
    let uimage = session.ch_uimage;
    let is_admin = session.ch_is_admin;
    if (ch_isLogin === "1") {
      this.setState({ uname: uname, uimage: uimage, is_admin: parseInt(is_admin) });
    }
  }


  static getDerivedStateFromProps(props, state) {
    let new_state = {};
    let flag = false;
    if (props.lang_version !== state.lang_version) {
      new_state.lang_version = props.lang_version;
      flag = true;
    }

    if (flag) {
      return new_state;
    }
    return null;
  }


  handLogoutAction() {
    Swal.fire({
      title: "Sign Out!",
      text: "Are you sure?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.value) {
        window.localStorage.setItem('ch_isLogin', "0")
        window.localStorage.setItem('ch_token', "")
        window.localStorage.setItem('ch_uname', "")
        window.localStorage.setItem('ch_uid', "")
        window.localStorage.setItem('ch_uimage', "")
        window.localStorage.setItem('ch_is_admin', "0")
        window.location.href = "#/";
      }
    });
  }

  loginAction() {
    let storage = window.localStorage;
    axios.post(storage.ch_action_url + "/action/login", Qs.stringify({
      email: this.state.email,
      password: this.state.password,
    })).then(res => {
      console.log(res);
      if (res.data.status === 0) {
        this.setState({ error_info: res.data.info })
      }
      else {
        let user = res.data.data;
        storage.setItem('ch_uid', user.uid);
        storage.setItem('ch_uname', user.uname);
        storage.setItem('ch_uimage', user.uimage);
        storage.setItem('ch_token', user.token);
        storage.setItem("ch_is_admin", user.is_admin);
        storage.setItem('ch_isLogin', "1");
        window.location.href = window.location.origin + "/home/all";
      }

    }).catch(error => {
      console.log(error);
    });
  }



  handleUserInfo() {
    let session = window.localStorage;

    let storage = window.localStorage;
        axios.post(storage.ch_action_url + "/action/update_user_image_name_password", Qs.stringify({
          token: storage.ch_token,
          name: this.state.uname,
          password: this.state.password,
          image: this.state.uimage
        })).then(res => {
          console.log(res);
          if (res.data.status === 0) {
            this.setState({ error_info: res.data.info })
          }
          else {
            storage.setItem('ch_uname', this.state.uname);
            storage.setItem('ch_uimage', this.state.uimage);
            window.location.href = window.location.origin + "/home/all";
          }

        }).catch(error => {
          console.log(error);
        });
  }





  updateLangVersion() {
    this.props.updateLangVersion();
  }

  triggerUploadUserImage() {
    let image_upload = document.getElementById("image_uploads_files");
    image_upload.click();
  }


  PostImageChange() {
    let final_this = this;
    let fileInput = document.getElementById("image_uploads_files");
    if (fileInput.files != null && fileInput.files[0] != null) {
      let reader = new FileReader();
      reader.onload = function (e) {
        let image = new Image();
        image.src = e.target.result;
        image.onload = function () {
          let height = this.height;
          let width = this.width;
          while (width >= 400 || height >= 400) {
            height = height / 2;
            width = width / 2;
          }
          let mainCanvas = document.createElement("canvas");
          mainCanvas.width = width;
          mainCanvas.height = height;
          var ctx = mainCanvas.getContext("2d");
          ctx.drawImage(image, 0, 0, mainCanvas.width, mainCanvas.height);
          let image_64 = mainCanvas.toDataURL("image/jpeg");
          final_this.setState({ uimage: image_64 });
          mainCanvas.remove();
        };
        fileInput.value = "";

      };
      reader.readAsDataURL(fileInput.files[0]);
    }
  }

  showUserSetting() {
    let session = window.localStorage;
    let ch_isLogin = session.ch_isLogin;
    let uname = session.ch_uname;
    let uimage = session.ch_uimage;
    let is_admin = session.ch_is_admin;
    this.setState({ uname: uname, uimage: uimage, show_user_setting: true, is_admin: parseInt(is_admin) });
  }

  render() {
    let session = window.localStorage;
    let ch_isLogin = session.ch_isLogin;
    let uname = session.ch_uname;
    let uimage = session.ch_uimage;
    let lang_data_user = LANG.header_user;
    let lang_data = LANG.login;

    return (
      <Fragment>
        <span className="mr-2">
          <Input type="select" name="select" size="sm" style={{padding:"0px", width:"50px", fontSize:"14px"}} id="lang_select_option" value={this.state.lang_version} onChange={() => this.updateLangVersion()}>
            <option value="ch">中文</option>
            <option value="en">EN</option>
          </Input>
          {/* <span style={{ cursor: "pointer", color: this.state.lang_version === "en" ? "white" : "#805151" }}>EN</span><span>/</span><span style={{ cursor: "pointer", color: this.state.lang_version === "ch" ? "white" : "#805151" }}>中文</span> */}
        </span>
        {ch_isLogin === "0" && <Button onClick={() => this.setState({ show_login: true })}
          color="neutral-first"
          className="bg-neutral-first text-first p-0 d-inline-block shadow-none border-0 text-center d-30 rounded btn-transition-none">
          <span>
            <FontAwesomeIcon icon={['fas', 'user']} />
          </span>
        </Button>}
        {ch_isLogin === "1" && <UncontrolledDropdown className="user-box position-relative ml-2">
          <DropdownToggle
            color="link"
            className="p-0 text-left d-flex align-items-center">
            <div className="d-block p-0 avatar-icon-wrapper">
              <Badge color="success" className="badge-circle p-top-a">
                Online
              </Badge>
              <div className="avatar-icon rounded" style={{ width: '30px', height: "30px" }} >
                <img alt="..." src={uimage.startsWith("data") ? uimage : (`${window.location.origin.toString()}` + "/" + uimage + "?time=" + (new Date()).getTime())} />
              </div>
            </div>
          </DropdownToggle>
          <DropdownMenu right className="dropdown-menu-lg overflow-hidden p-0">
            <ul className="list-group list-group-flush text-left bg-transparent">
              <li className="list-group-item rounded-top">
                <div style={{ textAlign: 'center' }} >
                  <div className="avatar-icon-wrapper avatar-icon-xl">
                    <div className="avatar-icon rounded-circle" style={{ width: '100px', height: "100px" }}>
                      <img alt="..." src={uimage.startsWith("data") ? uimage : (`${window.location.origin.toString()}` + "/" + uimage + "?time=" + (new Date()).getTime())} />
                    </div>
                  </div>
                </div>
                <div style={{ textAlign: 'center' }} >
                  {uname}
                </div>
              </li>
            </ul>
            <div className="card-footer bg-white p-3 text-center d-block">
              {this.state.is_admin !== 2 && <Button size="sm" color="dark" className="mr-1" onClick={() => this.showUserSetting()}>
                {this.state.lang_version === "ch" ? "设置" : "setting"}
              </Button>}
              <Button
                onClick={() => this.handLogoutAction()}
                size="sm"
                outline
                color="danger"
                className="ml-1"
                title="Sign out">
                {lang_data_user.logout_mesg}
              </Button>
            </div>
          </DropdownMenu>
        </UncontrolledDropdown>}
        <Modal zIndex={2000} centered isOpen={this.state.show_login}>
          <ModalHeader toggle={() => this.setState({ show_login: false })} />
          <ModalBody>
            <div className="pl-3 pr-3" style={{ width: '100%' }}>
              <div className="text-black mt-3">
                <span className="text-left text-sm-center">
                  <h1 className="display-3 text-lg-left text-center mb-3 font-weight-bold">
                    {lang_data.title_mesg}
                  </h1>
                </span>
                <div>
                  <form>
                    <FormGroup>
                      <label>{lang_data.email_label_mesg}</label>
                      <Input
                        placeholder="yourname@yourmail.com"
                        type="email"
                        onChange={(event) => { this.setState({ email: event.target.value }) }}
                        value={this.state.email}
                      />
                    </FormGroup>
                    <div className="form-group mb-4">
                      <div className="d-flex justify-content-between">
                        <label>{lang_data.password_label_mesg}</label>
                        <Link to="/forget_password">
                          {"Forget Password/Change Password?"}
                        </Link>
                      </div>
                      <Input
                        //placeholder="Enter your password"
                        type="password"
                        onChange={(event) => { this.setState({ password: event.target.value }) }}
                        value={this.state.password}
                      />
                      <div className="d-flex">
                        <span className="text-danger">{this.state.error_info}</span>
                      </div>
                    </div>

                    <Button size="lg" block={true} color="second" onClick={() => { this.loginAction() }}>
                      {lang_data.login_button_mesg}
                    </Button>
                  </form>
                </div>
                <div className="text-center pt-4 text-black-50">
                  {lang_data.not_account_laebl_mesg}{' '}
                  <Link to="/registeration">{lang_data.register_label_mesg}</Link>
                </div>
              </div>
            </div>

          </ModalBody>
        </Modal>

        <Modal zIndex={2000} centered isOpen={this.state.show_user_setting}>
          <ModalHeader toggle={() => this.setState({ show_user_setting: false })} >{this.state.lang_version === "ch" ? "个人设置" : "Profile Setting"}</ModalHeader>
          <ModalBody>
            <input type="file" multiple accept="image/png, image/gif, image/jpeg, image/bmp, image/x-icon" name="uploads" id="image_uploads_files" style={{ display: "none" }} onChange={() => this.PostImageChange()} />
            <div className="pl-3 pr-3" style={{ width: '100%' }}>
              <div className="text-center">
                <div className="avatar-icon-wrapper rounded-circle">
                  <div className="d-block p-0 avatar-icon-wrapper m-0">
                    <div className="rounded-circle border-3 border-white overflow-hidden">
                      <img src={getRealImageSrc(this.state.uimage)} className="avatar-icon rounded" alt="..." style={{ width: "150px", height: "150px" }} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <span onClick={() => this.triggerUploadUserImage()} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={['fas', 'camera']} style={{ fontSize: "30px" }} /></span>
              </div>
              <FormGroup>
                <label>{this.state.lang_version === "ch" ? "名称" : "Name"}</label>
                <Input
                  onChange={(event) => { this.setState({ uname: event.target.value }) }}
                  value={this.state.uname}
                />
              </FormGroup>
              <FormGroup>
                <span className="align-items-center mb-1 d-flex">
                  <span>{this.state.lang_version === "ch" ? "新的密码" : "New Password"}</span>
                  <span onClick={() => this.setState({ update_password: !this.state.update_password })} className="ml-2">
                    {!this.state.update_password && <FontAwesomeIcon icon={['far', 'square']} style={{ fontSize: "18px" }} />}
                    {this.state.update_password && <FontAwesomeIcon icon={['fas', 'check-square']} style={{ fontSize: "18px" }} />}
                  </span>
                </span>
                <Input disabled={this.state.update_password ? false : true}
                  onChange={(event) => { this.setState({ upassword: event.target.value }) }}
                  value={this.state.upassword}
                />
              </FormGroup>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="link" className="btn-link-dark" onClick={() => this.setState({ show_user_setting: false })}>{this.state.lang_version === "ch" ? "取消" : "Cancel"}</Button>{' '}
            <Button color="primary" className="ml-auto" onClick={() => this.handleUserInfo()}>{this.state.lang_version === "ch" ? "确定" : "Submit"}</Button>
          </ModalFooter>

        </Modal>

      </Fragment>
    );
  }
}